import { Component } from '@angular/core';
import { ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { BannerSliderComponent } from '../../shared/banner-slider/banner-slider.component';
import { OwlSliderComponent } from '../../shared/owl-slider/owl-slider.component';
import { CategoryComponent } from '../../shared/category/category.component';
import { CampaignBannerComponent } from '../../shared/campaign-banner/campaign-banner.component';

import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../core';
import { CatlougeTypeConstants } from '../../core/constants';

import { customDataForAssets, customDataForBanner, customDataForDummyData, customOptionsForBigSlider, customOptionsForFiveMiniSlider, customOptionsForFourMiniSlider, customOptionsForSevenMiniSlider, customOptionsForSixMiniSlider, customOptionsForThreeMiniSlider } from '../../shared/owl-slider-config';
import { Observable, BehaviorSubject, ReplaySubject, Subscription } from 'rxjs';

import { environment } from '../../../environments/environment';

import { AssetsService } from '../../core/services/assets.service';
import { CommonService } from '../../core/services/common.service';
import { PageTitleService } from '../../page-services/page-title.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CommonModule } from '@angular/common';
import { IndexedDBService } from '../../core/services/indexeddb.service';
import { ContinueWatchingService } from '../../core/services/continue-watching.service';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { redeemCodeAppliedOptions, errorOptions } from '../../shared/lottie-config';
@Component({
  selector: 'app-home',
  imports: [BannerSliderComponent,OwlSliderComponent,CategoryComponent,CampaignBannerComponent,NgbModule
    ,InfiniteScrollDirective,CommonModule, ImageManipulationComponent,TranslateModule, LottieComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  progressInc: number = 0;
  progrssBarValue: number = 0;
  userInfo: any;
  Location: any;
  owlBannerData: any = customDataForBanner; // = {banner_result: {banner: []}}; // 
  owlSliderData: any = customDataForDummyData;
  customOptionsForBigSlider = customOptionsForBigSlider
  customOptionsForFourMiniSlider = customOptionsForFourMiniSlider;
  customOptionsForFiveMiniSlider = customOptionsForFiveMiniSlider;
  customOptionsForSevenMiniSlider = customOptionsForSevenMiniSlider;
  customOptionsForSixMiniSlider = customOptionsForSixMiniSlider;
  customOptionsForThreeMiniSlider = customOptionsForThreeMiniSlider;
  private currentMenuSubject = new BehaviorSubject(false);
  public activeMenu = this.currentMenuSubject.asObservable();
  getCurrentSlug: string|null = '';

  homePageAssets: any;
  page: number = 1;
  tabDataParams: any;
  limit: number = 15;
  playListId: string = '';
  playListService: any;
  playListAvailable: boolean = false;
  playlist: any;
  routeName: any;
  // router: any;
  tempAsset_id: any;
  continueWatchingDataParams: any;
  loadMore: boolean= false;
  showContinueWatching: string|null = '';
  showAddBanner: boolean = false;
  selectedProfileName: string|null = '';
  selectedProfileImage: string = '';
  profileBasePath: string = '';
  showWelcomeCard: boolean = false;
  showPopupText: boolean = false;
  redeemResultSuccess: boolean = false;
  redeemResultMessage: string = '';
  redeemCodeAppliedOptions: AnimationOptions = redeemCodeAppliedOptions;
  @ViewChild('redeemCodeModal') redeemCodeModal!: ElementRef;
  isAuthenticated: string|null = '';
  isBannerDataFetched: boolean = false;
  isTabDataFetched: boolean = false;
  scrollData:any;
  private routeSub: Subscription;
  private continueWatchSubscription!: Subscription;
  private pendingRedeemResult: any = null;

  constructor(
    public route: ActivatedRoute,
    public userService: UserService,
    public assetsService: AssetsService,
    public commonService: CommonService,
    public router: Router,
    public pageTitleService: PageTitleService,
    public indexedDBService: IndexedDBService,
    public continueWatchingService: ContinueWatchingService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
  ) {
    // console.log('home component');
    
    // this.customOptionsForSevenMiniSlider = customOptionsForSevenMiniSlider;
    // this.customOptionsForSevenMiniSlider['slides'] = 7;
     // Subscribe to the route params observable to watch for parameter changes
     this.routeSub = this.route.params.subscribe((params) => {
      // this.slug = params['slug']; // Get the slug parameter
      // this.initializeContent();  // Call a method to reinitialize content when slug changes
    });

    // Initialize content when the component first loads
    // this.initializeContent();
  }

  ngOnInit(): void {
    // this.userService.updateSelectedMenu('home');
    this.initializeContent();
  }
  async initializeContent() {
    $(".dark").addClass("homeAndDetailPage");
    this.showContinueWatching = localStorage.getItem('continuewatching');
    this.liniarProgressBar();
    let currentUrl = this.route.snapshot.url.join('/');
    this.route.params.subscribe((param:any) => {
      currentUrl = param.slug ? param.slug : currentUrl;
    });
    // let currentUrl = this.route.snapshot.url.join('/');
    let firstTab = localStorage.getItem('tabs') ? JSON.parse(localStorage.getItem('tabs') as string)[0]?.slug:null;
    localStorage.setItem('slug', currentUrl || firstTab);
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') as string);
    this.getCurrentSlug = this.userService.getCurrentSlugName;
    // const pageTitle = JSON.parse(localStorage.getItem('tabs') as string).find((tab:any) => tab.slug === this.getCurrentSlug).name;
   // this.pageTitleService.setTitle(pageTitle);


    let bannerDataParams = {
      "slug": this.getCurrentSlug,
    };

    let continueWatchingtabDataParams = {
      "slug": this.getCurrentSlug,
      "page": 1,
      "limit": this.limit
    };

    this.tabDataParams = {
      "slug": this.getCurrentSlug,
      "page": 1,
      "size": this.limit
    };
    this.continueWatchingDataParams = this.userService.convertoJSONToUrlEncoded(continueWatchingtabDataParams);
    let allTabsDataParams = this.userService.convertoJSONToUrlEncoded(this.tabDataParams);
    let bannerPrams = this.userService.convertoJSONToUrlEncoded(bannerDataParams);
  //  await this.getBannerData(bannerPrams);
    setTimeout(() => {
       
      if (this.isAuthenticated) {
        // this.continueWatchingData(this.continueWatchingDataParams);
         this.continueWatchSubscription = this.continueWatchingService.getContinueWatchingObservable().subscribe(
          (data:any) => {
            // console.log('dashboard continue watch data', data);
            // console.log('owlBannerData',this.owlBannerData);
            const arr = Array.isArray(data) ? data : [data];

            const item = arr[0];  // normalize
            if (item && item.assets && item.assets.length > 0) {
              // remove duplcate entry of same series from continue watching
              const clonedData = structuredClone(arr); // ✅ deep copy
              const seenSeasons = new Set();
          
              clonedData[0].assets = clonedData[0].assets.filter((e: any) => {
                if (e.type === 'episode' || e.type === 'tvshow') {
                  if (!e.season_id) return false;
          
                  if (seenSeasons.has(e.series_code)) {
                    return false;
                  }
                  if(e.is_deleted) return false;
                  seenSeasons.add(e.series_code);
                  return true;
                }
          
                return true;
              });
              this.owlBannerData['result'] = [...clonedData]; // trigger Angular change detection

              // push blank test object to resolve last item hover preview issue
              //  this.owlBannerData?.result.forEach((ele: any, index: number) => {
              //   ele.assets.push({"code": "testcode","content_availability": "FREE"});
              // })
              // console.log("this.owlBannerData['result']",this.owlBannerData['result']);
              // console.log(" owlBannerData?.result", this.owlBannerData?.result);
              
            } else {
              this.owlBannerData['result'] = [];
            }
            
           
           
            // this.owlBannerData['result'] = [...data]; // Creates a new array reference to make Angular detect the change
          }
        );
      }
      this.getHomePageAssets(allTabsDataParams);
    }, 50);

    this.isAuthenticated = localStorage.getItem('isAuthenticated');
    this.profileBasePath = environment.api_url.replace('api/v1/', '');
    this.selectedProfileName = localStorage.getItem('profile_UserName');
    this.selectedProfileImage = localStorage.getItem('profileImageUrl') || '';

    if(localStorage.getItem('profileSelected')) {
      localStorage.removeItem('profileSelected');
      this.showWelcomeCard = true;
      setTimeout(() => {
        this.showWelcomeCard = false;
      }, 3500);
    }

    const redeemCodeResultRaw = localStorage.getItem('redeemCodeResult');
    if (redeemCodeResultRaw) {
      localStorage.removeItem('redeemCodeResult');
      try {
        this.pendingRedeemResult = JSON.parse(redeemCodeResultRaw);
      } catch (e) {
        console.error('error parsing redeem code result: ', e);
      }
    }

  }

  ngAfterViewInit() {
    const queryParams = { ...this.route.snapshot.queryParams };
    if (!this.userInfo && queryParams && queryParams['redirect_to_detail'] && queryParams['name'] && queryParams['code'] && queryParams['type']) {
      // you can use the non-null assertion operator (!) to tell TypeScript that the value will not be null
      document.getElementById('login-button')!.click();
    }
    
    if (!this.userInfo && queryParams && queryParams['redeem_login']) {
      document.getElementById('login-button')!.click();
    }
    if (this.pendingRedeemResult) {
      this.redeemResultSuccess = !!this.pendingRedeemResult.success;
      this.redeemResultMessage = this.pendingRedeemResult.message || '';
      this.redeemCodeAppliedOptions = this.redeemResultSuccess ? redeemCodeAppliedOptions : errorOptions;
      this.pendingRedeemResult = null;
      this.openRedeemCodeAppliedModal();
    }
  }

  openRedeemCodeAppliedModal() {
    this.showPopupText = false;
    this.modalService.open(this.redeemCodeModal, { ariaLabelledBy: 'modal-basic-title', backdrop: true, windowClass: 'delete_popup' }).result.then(() => { }, () => { });
    setTimeout(() => {
      this.showPopupText = true;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.modalService.dismissAll();
        // A successful redeem just activated/renewed a plan, so send the user to see it.
        if (this.redeemResultSuccess) {
          this.router.navigate(['/myplans']);
        }
      }, 2000);
    }, 300);
  }

  ngOnDestroy() {
    this.owlBannerData.banner_result.banner = [];
    $(".dark").removeClass("homeAndDetailPage");
  }

  // getBannerData(bannerPrams:any) {
  //   this.owlBannerData.banner_result.banner = [];
  //   this.assetsService.getBannerData(bannerPrams).subscribe((data:any) => {
  //     this.isBannerDataFetched = true;
  //     this.owlBannerData.banner_result.banner = data.result;
      
  //     setTimeout(() => {
  //       document.getElementById("nexg_ngb-progressbar")!.style.display = 'none';
  //       document.getElementById('maincontentarea')!.classList.remove("_beforeLoad");
  //     }, 500);
  //   });
  // }


  continueWatchingData(continueWatchingDataParams:any) {
    // this.owlBannerData.banner_result.banner = "";
    this.assetsService.getContinueWatchingData(continueWatchingDataParams).subscribe((data:any) => {
      this.owlBannerData['result'] = data.result;
      this.homePageAssets = data;
      this.indexedDBService.saveContinueWatching(data.result[0]);
    });
  }

removeHeight = false;
  getHomePageAssets(allTabsDataParams:any) {
  
    // this.owlBannerData.banner_result.banner = "";
    this.assetsService.getHomePageTabData(allTabsDataParams).subscribe((data:any) => {
      this.isTabDataFetched = true;
      
      this.owlSliderData = data;
       // push blank test object to resolve last item hover preview issue
      // this.owlSliderData?.result.forEach((ele: any, index: number) => {
      //    ele.assets.push({"code": "testcode","content_availability": "FREE"});
      // })
      // this.owlSliderData.result = data.result;
      setTimeout(() => {
        // console.log('owlSliderData.result in home component before filtering banner data',[...this.owlSliderData.result]);
      }, 5000);
      
      const bannerIndex = this.owlSliderData.result.findIndex((ele:any) => {
        return ele.category_disp_type == "feature_banner";
      }
      );
      if (bannerIndex != -1) {
        const bannerData = this.owlSliderData.result.splice(bannerIndex, 1);
        this.owlBannerData.banner_result.banner = bannerData[0].banners;
      }
      // setTimeout(() => {
      //   document.getElementById("nexg_ngb-progressbar")!.style.display = 'none';
      //   document.getElementById('maincontentarea')!.classList.remove("_beforeLoad");
      // }, 500);
      setTimeout(() => {
        this.showAddBanner = true;
      }, 3000);
       setTimeout(() => {
        this.removeHeight = true;
        // document.getElementById("nexg_ngb-progressbar")!.style.display = 'none';
        document.getElementById('maincontentarea')!.classList.remove("_beforeLoad");
      }, 500);
      // document.body.classList.add('page-animation');
        document.body.classList.add('page-animation-no-nav');
      setTimeout(() => {
        
        document.body.classList.remove('page-animation-no-nav');
      }, 800);
    });
  }

  onScroll() {
    let maxPage = Math.ceil(this.owlSliderData.total_count / this.limit);
    if (maxPage <= this.page) {
      this.loadMore = false;
      return;
    }
    this.loadMore = true;
    this.page++;
    this.tabDataParams['page'] = this.page;
    let dynamicTabsDataParams = this.userService.convertoJSONToUrlEncoded(this.tabDataParams);
    setTimeout(() => {
      this.assetsService.getHomePageTabData(dynamicTabsDataParams).subscribe((data:any) => {

        let rs = data.result;
        let preData = this.owlSliderData.result;
        this.owlSliderData.result = [...preData, ...rs];
        this.loadMore = true;
      });
    }, 100);

  }

  // deleteContinueWatching(item:any) {

  //   let categoryIndex = this.owlBannerData.result.findIndex((ele:any) => {
  //     return ele.category_code == 'HCTG008'
  //   });

  //   let assetsDataIndex = this.owlBannerData.result[categoryIndex].assets.findIndex((ele:any) => {
  //     return ele.asset_id == item.asset_id
  //   });
    
  //   let recentWatchedDelete = {
  //     asset_id: item.type == 'episode' ? item.show_id :item.asset_id,
  //     series_code: item.type == 'episode' ? item.series_code :'',
  //     // type: item.type,
  //     code:item.code
  //   }

  //   this.continueWatchingService.deleteContinueWatching(recentWatchedDelete).subscribe(data => {
  //     this.continueWatchingService.getContinueWatchingObservable();
  //      // Remove the asset from the local owlBannerData instead of reloading page
     
  //     // this.owlBannerData.result[categoryIndex] = {
  //     //   ...this.owlBannerData.result[categoryIndex],
  //     //   assets : [
  //     //     ...this.owlBannerData.result[categoryIndex].assets.slice(0, assetsDataIndex),
  //     //     ...this.owlBannerData.result[categoryIndex].assets.slice(assetsDataIndex + 1)
  //     // ]};

  //     document.getElementById('removeContinueModal')!.style.display = 'block';
  //     setTimeout(() => {
  //       document.getElementById('removeContinueModal')!.style.display = 'none';
  //     }, 3500);

  //   });

  //   // }

  // }

  deleteContinueWatching(item: any) {
    const categoryIndex = this.owlBannerData.result.findIndex(
      (ele: any) => ele.category_code === 'HCTG008'
    );

    if (categoryIndex === -1) return;

    const assetsDataIndex = this.owlBannerData.result[categoryIndex].assets.findIndex(
      (ele: any) => ele.asset_id === item.asset_id
    );

    if (assetsDataIndex === -1) return;

    const recentWatchedDelete = {
      asset_id: item.type === 'episode' ? item.show_id : item.asset_id,
      series_code: item.type === 'episode' ? item.series_code : '',
      code: item.code
    };

    // 1️⃣ Soft delete in IndexedDB first
    this.indexedDBService.deleteAssetFromContinueWatching(recentWatchedDelete)
      .then(() => {
        // 2️⃣ Remove from UI immediately
        
        this.owlBannerData.result[categoryIndex].assets.splice(assetsDataIndex, 1);

        // 3️⃣ Push updated data to subscribers
        this.continueWatchingService.getContinueWatchingObservable();

        // 4️⃣ Show confirmation
        // const modal = document.getElementById('removeContinueModal')!;
        // modal.style.display = 'block';
        // setTimeout(() => modal.style.display = 'none', 3500);

        // 5️⃣ Call API in background
        this.continueWatchingService.deleteContinueWatching(recentWatchedDelete)
          .subscribe({
             next: () => {
              setTimeout(() => {
                 // 4️⃣ Show confirmation
              const modal = document.getElementById('removeContinueModal')!;
              modal.style.display = 'block';
              setTimeout(() => modal.style.display = 'none', 3500);
              }, 100);
             
            },
            error: (err) => console.warn('⚠️ API delete failed, will retry:', err)
          });
      })
      .catch(err => console.error('❌ Local delete error:', err));
  }

  liniarProgressBar() {
    this.progressInc = 0;
    let progrssInterval = setInterval(() => {
      this.progrssBarValue = this.progressInc * 10;

      if (this.progressInc >= 10) {
        clearInterval(progrssInterval);
      }
      this.progressInc++;
    }, 500)

  }

  getWatchList() {

    this.playListId = localStorage.getItem('playListId')!;
    let temp = {
      playlistid: this.playListId ? this.playListId : '',
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      action: "getPlayListAsset1",
    }

    let urlEncodedPlayListAssetsParams = this.userService.convertoJSONToUrlEncoded(temp);
    this.playListService.getPlaylist(urlEncodedPlayListAssetsParams).subscribe((data:any) => {
      if (data && data.result && Array.isArray(data.result)) {
        if (Array.isArray(data.result)) {
          this.playListAvailable = true;
          this.playlist = data.result;
          this.check_into_watchlist()
          return this.playlist;
        }
      }
    });

  }

  check_into_watchlist() {
    this.routeName = this.router.url;
    this.homePageAssets?.result.forEach((categoryData:any, categoryIndex:any) => {

      if (categoryData.assets.length > 0) {
        this.homePageAssets?.result[categoryIndex].assets.forEach((tempAsset:any, tempIndex:any) => {

          if (this.routeName == '/') {
            this.tempAsset_id = tempAsset.asset_mongo_id;
          } else if (this.routeName == '/tvshows') {
            this.tempAsset_id = tempAsset.asset_mongo_id;
          } else if (this.routeName == '/movies') {
            this.tempAsset_id = tempAsset._id;
          } else if (this.routeName == '/livetv') {
            this.tempAsset_id = tempAsset._id;
          }

          if (this.playlist.findIndex((tempObj:any) => tempObj._id == this.tempAsset_id) != -1) {
            this.homePageAssets.result[categoryIndex].assets[tempIndex].is_watchlist_added = true;
          } else {
            this.homePageAssets.result[categoryIndex].assets[tempIndex].is_watchlist_added = false;
          }
        });
      }

      if (categoryIndex >= this.homePageAssets?.result.length - 1) {
       
        this.owlSliderData = this.homePageAssets;
        document.getElementById("nexg_ngb-progressbar")!.style.display = 'none';
        document.getElementById('maincontentarea')!.classList.remove("_beforeLoad");
        // return true;
      }
    });
    return true;
  }

}
